// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__dcxzf","signatureButtonsRight":"ModalSign_signatureButtonsRight__2cyuW"};